import { getTableData, getRole, save, check, update, deleteWhiteList, find, updateForBatch, analysisUsers, deleteRoles, assignRoles, updateStatus, getRegisteredAccount, findCompanyFilter, findGroupFilter, getSuffixList, getCustomerCompanyData, getCustomerGroupData, getCustomerCompanyTableData, updateCustomerCompanyStatus, deleteCustomerCompany, updateCustomerCompany, findCustomerCompany } from '@/axios/api/whiteList'
import { Message } from 'element-ui'

const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_DOMAIN_TABLEDATA = 'UPDATE_DOMAIN_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_DOMAIN_TBL_LOADING = 'UPDATE_DOMAIN_TBL_LOADING'
const UPDATE_CUSTOMER_COMPANY_TBL_LOADING = 'UPDATE_CUSTOMER_COMPANY_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_DOMAIN_TOTAL = 'UPDATE_DOMAIN_TOTAL'
const UPDATE_CUSTOMER_COMPANY_TOTAL = 'UPDATE_CUSTOMER_COMPANY_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_DOMAIN_SEARCH = 'UPDATE_DOMAIN_SEARCH'
const UPDATE_ROLE_LIST = 'UPDATE_ROLE_LIST'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_DETAIL_LOADING = 'UPDATE_DETAIL_LOADING'
const UPDATE_ACCOUNT_PAGER = 'UPDATE_ACCOUNT_PAGER'
const UPDATE_ACCOUNT_DATA = 'UPDATE_ACCOUNT_DATA'
const UPDATE_ACCOUNT_LOADING = 'UPDATE_ACCOUNT_LOADING'
const UPDATE_CUSTOMER_COMPANY_DATA = 'UPDATE_CUSTOMER_COMPANY_DATA'
const UPDATE_CUSTOMER_GROUP_DATA = 'UPDATE_CUSTOMER_GROUP_DATA'
const UPDATE_DOMAIN_CUSTOMER_COMPANY_DATA = 'UPDATE_DOMAIN_CUSTOMER_COMPANY_DATA'
const UPDATE_DOMAIN_CUSTOMER_GROUP_DATA = 'UPDATE_DOMAIN_CUSTOMER_GROUP_DATA'
const UPDATE_CUSTOMER_CUSTOMER_COMPANY_DATA = 'UPDATE_CUSTOMER_CUSTOMER_COMPANY_DATA'
const UPDATE_CUSTOMER_CUSTOMER_GROUP_DATA = 'UPDATE_CUSTOMER_CUSTOMER_GROUP_DATA'
const UPDATE_PERSONAL_CUSTOMER_COMPANY_DATA = 'UPDATE_PERSONAL_CUSTOMER_COMPANY_DATA'
const UPDATE_PERSONAL_CUSTOMER_GROUP_DATA = 'UPDATE_PERSONAL_CUSTOMER_GROUP_DATA'
const UPDATE_CUSTOMER_COMPANY_SEARCH = 'UPDATE_CUSTOMER_COMPANY_SEARCH'
const UPDATE_CUSTOMER_COMPANY_TABLEDATA = 'UPDATE_CUSTOMER_COMPANY_TABLEDATA'
const UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING = 'UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING'
const UPDATE_CUSTOMER_COMPANY_DETAIL = 'UPDATE_CUSTOMER_COMPANY_DETAIL'

const state = {
  tableData: [],
  domainTableData: [],
  customerCompanyTableData: [],
  registeredAccountData: [],
  tblLoading: false,
  accountLoading: false,
  domainTblLoading: false,
  customerCompanyTblLoading: false,
  detailLoading: false,
  customerCompanyDetailLoading: false,
  roleList: [],
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  domainPager: {
    current: 1,
    size: 10,
    total: 0
  },
  customerCompanyPager: {
    current: 1,
    size: 10,
    total: 0
  },
  accountPager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
    customerCompanyIds: [],
    customerGroupId: undefined,
    account: undefined,
    roleId: undefined,
    registerStatus: undefined,
    userType: undefined
  },
  domainParams: {
    customerCompanyIds: [],
    customerGroupId: undefined,
    account: undefined,
    roleId: undefined,
    dataStatus: undefined,
    userType: undefined
  },
  customerProductParams: {
    customerCompany: undefined,
    customerCompanyIds: [],
    customerGroup: undefined,
    customerGroupId: undefined,
    status: undefined,
    intoSource: undefined
  },
  detail: {},
  customerCompanyData: [],
  customerGroupData: [],
  domainCustomerCompanyData: [],
  domainCustomerGroupData: [],
  personalCustomerCompanyData: [],
  personalCustomerGroupData: [],
  customerCustomerCompanyData: [],
  customerCustomerGroupData: [],
  customerCompanyDetail: {}
}
const getters = {
  tableData: state => state.tableData,
  domainTableData: state => state.domainTableData,
  customerCompanyTableData: state => state.customerCompanyTableData,
  registeredAccountData: state => state.registeredAccountData,
  tblLoading: state => state.tblLoading,
  accountLoading: state => state.accountLoading,
  domainTblLoading: state => state.domainTblLoading,
  detailLoading: state => state.detailLoading,
  pager: state => state.pager,
  domainPager: state => state.domainPager,
  customerCompanyPager: state => state.customerCompanyPager,
  accountPager: state => state.accountPager,
  params: state => state.params,
  domainParams: state => state.domainParams,
  roleList: state => state.roleList,
  detail: state => state.detail,
  customerCompanyData: state => state.customerCompanyData,
  customerGroupData: state => state.customerGroupData,
  customerProductParams: state => state.customerProductParams,
  customerCompanyTblLoading: state => state.customerCompanyTblLoading,
  customerCompanyDetailLoading: state => state.customerCompanyDetailLoading,
  customerCompanyDetail: state => state.customerCompanyDetail,
  domainCustomerCompanyData: state => state.domainCustomerCompanyData,
  domainCustomerGroupData: state => state.domainCustomerGroupData,
  customerCustomerCompanyData: state => state.customerCustomerCompanyData,
  customerCustomerGroupData: state => state.customerCustomerGroupData,
  personalCustomerCompanyData: state => state.personalCustomerCompanyData,
  personalCustomerGroupData: state => state.personalCustomerGroupData
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = tableData
  },
  [UPDATE_DOMAIN_TABLEDATA] (state, domainTableData) {
    state.domainTableData = domainTableData
  },
  [UPDATE_CUSTOMER_COMPANY_TABLEDATA] (state, customerCompanyTableData) {
    state.customerCompanyTableData = customerCompanyTableData
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_DOMAIN_TOTAL] (state, total) {
    state.domainPager = { ...state.domainPager, total }
  },
  [UPDATE_CUSTOMER_COMPANY_TOTAL] (state, total) {
    state.customerCompanyPager = { ...state.customerCompanyPager, total }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_DOMAIN_TBL_LOADING] (state, domainTblLoading) {
    state.domainTblLoading = domainTblLoading
  },
  [UPDATE_CUSTOMER_COMPANY_TBL_LOADING] (state, customerCompanyTblLoading) {
    state.customerCompanyTblLoading = customerCompanyTblLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  },
  [UPDATE_DOMAIN_SEARCH] (state, { pager, params }) {
    state.domainPager = { ...state.domainPager, ...pager }
    if (params) state.domainParams = params
  },
  [UPDATE_CUSTOMER_COMPANY_SEARCH] (state, { pager, params }) {
    state.customerCompanyPager = { ...state.customerCompanyPager, ...pager }
    if (params) state.customerProductParams = params
  },
  [UPDATE_ROLE_LIST] (state, roleList) {
    state.roleList = roleList
  },
  [UPDATE_DETAIL_LOADING] (state, detailLoading) {
    state.detailLoading = detailLoading
  },
  [UPDATE_DETAIL] (state, detail) {
    state.detail = detail
  },
  [UPDATE_ACCOUNT_PAGER] (state, pager) {
    state.accountPager = {
      ...state.accountPager,
      ...pager
    }
  },
  [UPDATE_ACCOUNT_DATA] (state, data) {
    state.registeredAccountData = data
  },
  [UPDATE_ACCOUNT_LOADING] (state, loading) {
    state.accountLoading = loading
  },
  [UPDATE_CUSTOMER_COMPANY_DATA] (state, customerCompanyData) {
    state.customerCompanyData = customerCompanyData
  },
  [UPDATE_CUSTOMER_GROUP_DATA] (state, customerGroupData) {
    state.customerGroupData = customerGroupData
  },
  [UPDATE_DOMAIN_CUSTOMER_COMPANY_DATA] (state, customerCompanyData) {
    state.domainCustomerCompanyData = customerCompanyData
  },
  [UPDATE_DOMAIN_CUSTOMER_GROUP_DATA] (state, customerGroupData) {
    state.domainCustomerGroupData = customerGroupData
  },
  [UPDATE_CUSTOMER_CUSTOMER_COMPANY_DATA] (state, customerCustomerCompanyData) {
    state.customerCustomerCompanyData = customerCustomerCompanyData
  },
  [UPDATE_CUSTOMER_CUSTOMER_GROUP_DATA] (state, customerCustomerGroupData) {
    state.customerCustomerGroupData = customerCustomerGroupData
  },
  [UPDATE_PERSONAL_CUSTOMER_COMPANY_DATA] (state, customerCompanyData) {
    state.personalCustomerCompanyData = customerCompanyData
  },
  [UPDATE_PERSONAL_CUSTOMER_GROUP_DATA] (state, customerGroupData) {
    state.personalCustomerGroupData = customerGroupData
  },
  [UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING] (state, customerCompanyDetailLoading) {
    state.customerCompanyDetailLoading = customerCompanyDetailLoading
  },
  [UPDATE_CUSTOMER_COMPANY_DETAIL] (state, customerCompanyDetail) {
    state.customerCompanyDetail = customerCompanyDetail
  }
}

const actions = {
  // 获取列表数据
  async getTableDataApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData({
        ...params,
        matchingMode: 'PERSON'
      })
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_TBL_LOADING, false)
  },
  // 获取列表数据
  async getDomainTableDataApi ({ commit }, params) {
    commit(UPDATE_DOMAIN_TBL_LOADING, true)
    try {
      let { data: res } = await getTableData({
        ...params,
        matchingMode: 'DOMAIN'
      })
      commit(UPDATE_DOMAIN_TABLEDATA, res.records)
      commit(UPDATE_DOMAIN_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_DOMAIN_TBL_LOADING, false)
  },
  // 获取列表数据
  async getCustomerCompanyTableDataApi ({ commit }, params) {
    commit(UPDATE_CUSTOMER_COMPANY_TBL_LOADING, true)
    try {
      let { data: res } = await getCustomerCompanyTableData({
        ...params
      })
      commit(UPDATE_CUSTOMER_COMPANY_TABLEDATA, res.records)
      commit(UPDATE_CUSTOMER_COMPANY_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_CUSTOMER_COMPANY_TBL_LOADING, false)
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  // 设置page
  setDomainPagerApi ({ commit }, pager) {
    commit(UPDATE_DOMAIN_SEARCH, { pager })
  },
  // 设置page
  setCustomerCompanyPagerApi ({ commit }, pager) {
    commit(UPDATE_CUSTOMER_COMPANY_SEARCH, { pager })
  },
  changeLoadingApi ({ commit }, flag) {
    commit(UPDATE_TBL_LOADING, flag)
  },
  // 获取role
  async getRoleApi ({commit}, keyword = '') {
    try {
      let { data: res } = await getRole({keyword})
      commit(UPDATE_ROLE_LIST, res)
      return res
    } catch (e) {
      return false
    }
  },
  // 获取详情
  async getDetailApi ({ commit }, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const {data: res} = await find(params)
      commit(UPDATE_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 新增白名单
  async saveApi ({commit}, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await save(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res
    } catch (e) {
    }
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 校验account
  async checkApi ({commit}, params) {
    try {
      const {data: res} = await check(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 编辑白名单
  async updateApi ({commit}, params) {
    commit(UPDATE_DETAIL_LOADING, true)
    try {
      const res = await update(params)
      commit(UPDATE_DETAIL_LOADING, false)
      return res
    } catch (e) {
    }
    commit(UPDATE_DETAIL_LOADING, false)
  },
  // 删除白名单
  async deleteApi ({commit}, params) {
    try {
      await deleteWhiteList(params)
      Message.success('success')
      return true
    } catch (e) {
      return false
    }
  },
  // 删除
  async deleteCustomerCompanyApi ({commit}, params) {
    try {
      await deleteCustomerCompany(params)
      Message.success('success')
      return true
    } catch (e) {
      return false
    }
  },
  // 批量更新
  async updateForBatchApi ({commit}, params) {
    try {
      await updateForBatch(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 批量解析
  async analysisUsersApi ({ commit }, params) {
    try {
      const { data: res } = await analysisUsers(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 批量删除角色
  async deleteRolesApi ({commit}, params) {
    try {
      const { data: res } = await deleteRoles(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 批量编辑角色
  async assignRolesApi ({commit}, params) {
    try {
      await assignRoles(params)
      return true
    } catch (e) {
      return false
    }
  },
  // 更新状态白名单
  async updateStatusApi ({commit}, params) {
    try {
      const { data: res } = await updateStatus(params)
      return res
    } catch (e) {
      return false
    }
  },
  // 更新状态白名单
  async updateCustomerCompanyStatusApi ({commit}, params) {
    try {
      const { data: res } = await updateCustomerCompanyStatus(params)
      return res
    } catch (e) {
      return false
    }
  },
  async getRegisteredAccountApi ({ commit }, params) {
    commit(UPDATE_ACCOUNT_LOADING, true)
    try {
      let { data: res } = await getRegisteredAccount(params)
      commit(UPDATE_ACCOUNT_DATA, res.records)
      commit(UPDATE_ACCOUNT_PAGER, {
        total: res.total
      })
    } catch (e) { }
    commit(UPDATE_ACCOUNT_LOADING, false)
  },
  setAccountPagerApi ({ commit }, pager) {
    commit(UPDATE_ACCOUNT_PAGER, pager)
  },
  async findCompanyFilterApi ({ commit }, params) {
    try {
      const { data: res } = await findCompanyFilter(params)
      return (res || []).map(v => {
        return {
          value: v
        }
      })
    } catch (e) {}
  },
  async findGroupFilterApi ({ commit }, params) {
    try {
      const { data: res } = await findGroupFilter(params)
      return (res || []).map(v => {
        return {
          value: v
        }
      })
    } catch (e) {}
  },
  async getSuffixListApi ({ commit }, params) {
    try {
      let { data: res } = await getSuffixList(params)
      return res
    } catch (e) { }
  },
  // 获取company
  async getCustomerCompanyDataApi ({state, commit}, params) {
    try {
      const { data: res } = await getCustomerCompanyData(params)
      commit(UPDATE_CUSTOMER_COMPANY_DATA, res || [])
      return res || []
    } catch (e) {}
  },
  // group
  async getCustomerGroupDataApi ({state, commit}, params) {
    try {
      const { data: res } = await getCustomerGroupData(params)
      commit(UPDATE_CUSTOMER_GROUP_DATA, res || [])
      return res || []
    } catch (e) {}
  },
  // 获取详情
  async findCustomerCompanyApi ({ commit }, params) {
    commit(UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING, true)
    try {
      const {data: res} = await findCustomerCompany(params)
      commit(UPDATE_CUSTOMER_COMPANY_DETAIL, res)
    } catch (e) {}
    commit(UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING, false)
  },
  // 编辑
  async updateCustomerCompanyApi ({commit}, params) {
    commit(UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING, true)
    try {
      const res = await updateCustomerCompany(params)
      Message.success('success')
      commit(UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING, false)
      return res && res.errorCode === 200
    } catch (e) {
    }
    commit(UPDATE_CUSTOMER_COMPANY_DETAIL_LOADING, false)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/whiteList.js